<template>

    <van-dialog
            v-model="bookShow"
            @close="onClose"
            :showConfirmButton="showConfirmButton"
            :closeOnClickOverlay="closeOnClickOverlay"
    >
        <div class="wxdialog" >
            <img :src="wxPic" />
            <div class="wxcode">客服微信：{{wxCode}}</div>
            <div class="wxNote">{{wxNote}}</div>
            <div class="wxNote" >
                {{phone}}
                <van-button  type="info" size="mini" @click="openPhone(phone)">拨打电话</van-button>
            </div>

            <van-button type="danger"
                        v-clipboard:copy="wxCode"
                        v-clipboard:success="onCopy"
            >点击复制或长按图片识别，添加好友</van-button>
        </div>
    </van-dialog>
</template>

<script>
    import Vue from 'vue'
    import {
        Dialog,Button,Toast
    } from 'vant';

    Vue.use(Dialog).use(Button).use(Toast);
    export default {
        name: "BookDialog",
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            wxCode: {
                type: String,
                default: ''
            },
            wxNote: {
                type: String,
                default: ''
            },
            phone: {
                type: String,
                default: ''
            },
            wxPic: {
                type: String,
                default: ''
            },
        },
        watch: {
            show(val) {
                this.bookShow = val

                console.log('show '+val);
            }
        },
        data: function() {
            return {
                bookShow: false,
                showConfirmButton: false,
                closeOnClickOverlay: true,
            }
        },
        methods:{
            onClose() {
                this.$emit('onBookCancle', {})
            },

            openPhone(phoneNumber) {
                Dialog.confirm({
                    message: '拨打'+phoneNumber+'？'
                }).then(() => {
                    // 调用拨号功能
                    window.location.href = 'tel://' + phoneNumber
                }).catch(() => {
                    // on cancel
                });

            },
            onCopy() {
                Toast.success('复制成功')
                this.onClose()
            }
        }
    }
</script>

<style scoped>
    .wxdialog{
        text-align: center;
        padding: 20px;
    }

    .wxdialog img{
        width: 100px;
        height: 100px;
    }

    .wxcode{
        font-weight: bold;
        font-size: 16px;
        line-height: 40px;
    }
    .wxNote{
        font-size: 15px;
        line-height: 30px;
        color:#666
    }

</style>


// WEBPACK FOOTER //
// BookDialog.vue?fc5f14dc